/**
 * 部署
 */
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import DeptKv from '@/_components/dept-kv.vue';
import Carousel from '@/_components/carousel.vue';
import CarouselCase from '@/_components/carousel-case.vue';
import CarouselWorks from '@/_components/carousel-works.vue';
import Related from '@/_components/related.vue';
import RelatedSp from '@/_components/related-sp.vue';
import CommonPlugin from '@/_modules/common/common-plugin'
Vue.use(CommonPlugin);

import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
import hover from '@/_modules/common/hover';
window.$scrollManager = scrollManager;

export default class AppDept {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppDept';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi,
        DeptKv,
        Carousel,
        CarouselCase,
        CarouselWorks,
        Related,
        RelatedSp
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          isShowMore: false,
          params: [],
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        const scriptWorks = document.getElementById('js-param-moreworks');
        if (scriptWorks) {
          this.params = JSON.parse(scriptWorks.textContent);
        }
        
        $scrollManager.init();

        document.querySelectorAll('.c-memberList__set').forEach((el, index) => {
          new hover(el, index);
        });

        document.querySelectorAll('.c-worksList__set').forEach((el, index) => {
          new hover(el, index);
        });
        
        this.$nextTick(this.start);
      },
      methods: {
        start() {
          this.$store.commit('setShowCoverOut', false);
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        },
        checkParent(terms) {
          return terms.filter(function (item) {
            return (item.parent === 0);
          })
        },
        showMore() {
          this.$_showMoreCookie();
          this.isShowMore = true;

          this.$nextTick(this.showMoreComp);
        },
        showMoreComp() {
          document.getElementById('c-worksList--more').querySelectorAll('.c-worksList__hover').forEach((el, index) => {
            new hover(el, index);
          });
        }
      }
    });
  }
}
